export const firestoreCollections = {
  events: '_events',
  holidays: 'holidays',
  travelers: '_travelers',
  productionZones: '_productionZones',
  employees: '_employees',
  productionResourceIds: '_productionResourceIds',
  timeOffRequests: 'timeOffRequests',
  users: 'users',
} as const;

export const firestoreDocumentPaths = {
  emailApi: 'env/emailApi',
  calendar: 'env/calendar',
} as const;
